import { useState, useEffect, forwardRef } from 'react';
import { getSignedMediaUrl } from '../services/api';

// <video> pentru fișiere LOCALE protejate. Fișierele nu mai sunt expuse static la /uploads — se
// obține întâi un URL semnat scurt (autorizat pe resursă) prin /media/sign, apoi se redă cu suport
// Range din /media/stream. Forward-ref pentru a păstra accesul la elementul <video> (tracking progres).
//
// `path` e calea relativă „/uploads/...". Celelalte props se transmit direct elementului <video>.
const SecureVideo = forwardRef(
  ({ path, fallbackClassName = 'w-full h-full', ...videoProps }, ref) => {
    const [src, setSrc] = useState(null);

    useEffect(() => {
      let active = true;
      setSrc(null);
      getSignedMediaUrl(path).then((u) => {
        if (active) setSrc(u);
      });
      return () => {
        active = false;
      };
    }, [path]);

    if (!src) {
      return (
        <div className={`${fallbackClassName} flex items-center justify-center bg-black`}>
          <div className="animate-spin rounded-full h-10 w-10 border-2 border-white border-t-transparent" />
        </div>
      );
    }

    return <video ref={ref} src={src} {...videoProps} />;
  }
);

SecureVideo.displayName = 'SecureVideo';

export default SecureVideo;
